// extracted by mini-css-extract-plugin
export default {"spec":"index_spec__YYTWW","item":"index_item__AwXVL","icon":"index_icon__DTT8Z","activate":"index_activate__m9uMc","disable":"index_disable__RPJVw"};